import React, { useMemo } from "react";
import Box from "@mui/material/Box";

function tileBackgroundPosition(sliceIndex, gridSize) {
    const gs = Math.max(1, Number(gridSize) || 1);
    const col = sliceIndex % gs;
    const row = Math.floor(sliceIndex / gs);
    if (gs <= 1) return "0% 0%";
    return `${(col / (gs - 1)) * 100}% ${(row / (gs - 1)) * 100}%`;
}

const DEFAULT_OFFSETS = [
    { top: "8%", left: "-6%", rotate: -16, size: 72, opacity: 0.9, slice: 0 },
    { top: "22%", right: "-22%", rotate: 14, size: 64, opacity: 0.85, slice: 2 },
    { top: "58%", left: "-8%", rotate: 10, size: 58, opacity: 0.8, slice: 5 },
    { top: "72%", right: "-22%", rotate: -12, size: 68, opacity: 0.88, slice: 7 },
    { top: "40%", left: "4%", rotate: -6, size: 48, opacity: 0.55, slice: 3 },
    { top: "48%", right: "3%", rotate: 18, size: 44, opacity: 0.5, slice: 6 },
];

/**
 * Soft floating puzzle-piece shapes for collection / themes screenshots.
 * Uses cover images when available; otherwise soft geometric tiles.
 */
export default function ScreenshotFloatingPieces({ imageUrls = [] }) {
    const tiles = useMemo(() => {
        const urls = (imageUrls || []).filter(Boolean);
        return DEFAULT_OFFSETS.map((cfg, i) => ({
            ...cfg,
            imageUrl: urls[i % Math.max(urls.length, 1)] || null,
            gridSize: 3,
        }));
    }, [imageUrls]);

    return (
        <Box
            aria-hidden
            sx={{
                position: "absolute",
                inset: 0,
                overflow: "hidden",
                pointerEvents: "none",
                zIndex: 0,
            }}
        >
            {tiles.map((tile, i) => (
                <Box
                    key={i}
                    sx={{
                        position: "absolute",
                        top: tile.top,
                        left: tile.left,
                        right: tile.right,
                        width: tile.size,
                        height: tile.size,
                        borderRadius: "12px",
                        overflow: "hidden",
                        opacity: tile.opacity,
                        transform: `rotate(${tile.rotate}deg)`,
                        backgroundColor: "rgba(15,23,42,0.08)",
                        backgroundImage: tile.imageUrl ? `url("${tile.imageUrl}")` : "none",
                        backgroundSize: tile.imageUrl
                            ? `${tile.gridSize * 100}% ${tile.gridSize * 100}%`
                            : "auto",
                        backgroundPosition: tile.imageUrl
                            ? tileBackgroundPosition(tile.slice, tile.gridSize)
                            : "center",
                        backgroundRepeat: "no-repeat",
                        boxShadow:
                            "0 0 0 2px rgba(255,255,255,0.75), 0 12px 28px rgba(15,23,42,0.18)",
                        filter: "saturate(1.05)",
                    }}
                />
            ))}
        </Box>
    );
}
